import { useState } from "react";
import { AcessoDosServicos } from "../componentes/operacao/AcessoDosServicos";
import { PainelDeAgendamentos } from "../componentes/chamados/PainelDeAgendamentos";
import { PainelDeCampos } from "../componentes/chamados/PainelDeCampos";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "campos" | "agenda" | "servicos";

const ABAS = [
  { chave: "campos", rotulo: "Campos personalizados" },
  { chave: "agenda", rotulo: "Aberturas programadas" },
  { chave: "servicos", rotulo: "Catálogo de serviços" },
] as const;

/** Configuração do atendimento que muda o que um chamado carrega e quando ele nasce. */
export function ConfiguracaoDosChamados() {
  useTitulo("Configurar chamados");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba>("campos");

  if (!sessao.data) return <p className="lead" role="status">Verificando o seu acesso…</p>;
  if (!podeNaSessao(sessao.data, "ticket:configurar")) {
    return (
      <Aviso tom="marca" data-testid="configuracao-sem-permissao">
        Os campos personalizados e as aberturas programadas são mantidos pela administração do portal.
      </Aviso>
    );
  }

  return (
    <div data-testid="configuracao-dos-chamados">
      <h1 className="titulo-pagina">Configurar chamados</h1>
      <p className="lead mb-4">
        Campos que cada chamado carrega (visíveis ao cliente ou só da equipe) e chamados que o portal abre sozinho, uma vez ou de forma recorrente.
      </p>
      <Abas rotulo="Configuração dos chamados" id="configuracao-dos-chamados" itens={ABAS} ativa={ativa} aoSelecionar={setAtiva} className="mb-4" />
      <PainelDaAba id="configuracao-dos-chamados" chave="campos" ativa={ativa} data-testid="painel-campos"><PainelDeCampos /></PainelDaAba>
      <PainelDaAba id="configuracao-dos-chamados" chave="agenda" ativa={ativa} data-testid="painel-agenda"><PainelDeAgendamentos /></PainelDaAba>
      <PainelDaAba id="configuracao-dos-chamados" chave="servicos" ativa={ativa} data-testid="painel-servicos"><AcessoDosServicos /></PainelDaAba>
    </div>
  );
}
